// test680
(680 && 0);
